// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1TUhD","rootSuccess":"CompleteLink_rootSuccess__3OovO","rootFailure":"CompleteLink_rootFailure__1J1Zg","isDisabled":"CompleteLink_isDisabled__32HNj"};